import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Navbar from './components/ui/Navbar';
import Loading from './components/ui/Loading';
import ScrollProgress from './components/ui/ScrollProgress';
import BackToTop from './components/ui/BackToTop';
import Footer from './components/sections/Footer';
import StructuredData from './components/StructuredData';
import ErrorBoundary from './components/ErrorBoundary';
import GoogleAnalytics from './components/GoogleAnalytics';

// Pages
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

// Hooks
import { useScrollProgress } from './components/hooks/useScrollProgress';
import { useCounters } from './components/hooks/useCounters';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const { scrollProgress, showBackToTop, scrollToTop } = useScrollProgress();
  const counters = useCounters(isLoading);

  // Loading animation effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  // Loading Screen
  if (isLoading) {
    return <Loading />;
  }

  return (
    <ErrorBoundary>
      <Router>
        <div className="min-h-screen bg-white">
          {/* Google Analytics */}
          <GoogleAnalytics />

          {/* Structured Data for SEO */}
          <StructuredData type="Organization" data={{}} />
          <StructuredData type="WebSite" data={{}} />
          <StructuredData type="LocalBusiness" data={{}} />

          {/* Scroll Progress Bar */}
          <ScrollProgress progress={scrollProgress} />

          {/* Back to Top Button */}
          <BackToTop show={showBackToTop} onClick={scrollToTop} />

          {/* Navigation */}
          <Navbar scrollProgress={scrollProgress} />

          {/* Main Content */}
          <Routes>
            <Route path="/" element={<Home counters={counters} />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About counters={counters} />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>

          {/* Footer */}
          <Footer />
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
